import axios from "@/axios";

export const authApi = {
  /**
   * POST auth/switch-role
   * Switch the role the user is currently acting as
   * @param {number|string} roleId
   */
  switchRole(roleId) {
    return axios.post("auth/switch-role", { role_id: roleId });
  },
};
